<template>
    <span>
        <a href="#" v-if="isFavorited" @click.prevent="unFavorite(spa)">
            <div class="fave-heart is_animating"></div>
        </a>
        <a href="#" v-else @click.prevent="favorite(spa)">
            <div class="fave-heart"></div>
        </a>
        <div class="fave-count">{{ this.faveCount > 0 ? this.faveCount : "" }}</div>
    </span>
</template>
<script>
    export default {
        props: ['spa', 'favorited', 'count', 'loggedin'],

        data: function() {
            return {
                isFavorited: '',
                faveCount: this.count,
                loggedIn: this.loggedin
            }

        },
        mounted() {
            this.isFavorited = this.isFavorite ? true : false;
        },
        computed: {
            isFavorite() {
                return this.favorited;
            },
        },

        methods: {
            favorite(spa) {
                if (this.loggedIn === 1) {
                    axios.post('/favorite/' + spa)
                        .then(
                            response => this.isFavorited = true,
                            this.faveCount = this.faveCount + 1
                        )
                        .catch(response => console.log(response.data));
                } else {
                    swal({
                        title: "Sorry",
                        text: "You must be signed in to add spas to your favourites",
                        icon: "warning",
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
            },

            unFavorite(spa) {
                if (this.loggedIn === 1) {
                    axios.post('/unfavorite/'+spa)
                        .then(
                            response => this.isFavorited = false,
                            this.faveCount = this.faveCount-1
                        )
                        .catch(response => console.log(response.data));
                } else {
                    console.log('unlogged in? ' + this.loggedIn);
                    swal({
                        title: "Sorry",
                        text: "You must be signed in to add spas to your favourites",
                        icon: "warning",
                        timer: 2000,
                        confirm: false
                    });
                }
            }
        }
    }

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Favorite.vue